export const selectOptionsWireStatus = ["Released for Payment", "Tee-up Done"];
